export const vehicles = [
  {
    id: 1,
    brand: "Ford",
    model: "Transit Custom",
    year: 2020,
    km: 87000,
    price: 22500,
    fuel: "Diésel",
    transmission: "Manual",
    color: "Blanco",
    description: "Furgoneta en excelente estado, revisiones al día, ideal para transporte de mercancías. Un solo propietario.",
    image: "https://public.readdy.ai/ai/img_res/ff86a05604645764c452223e608ddd57.jpg",
    badge: "Destacado",
  },
  {
    id: 2,
    brand: "Mercedes-Benz",
    model: "Vito",
    year: 2019,
    km: 98000,
    price: 5990,
    fuel: "Diésel",
    transmission: "Manual",
    color: "Azul",
    description: "Mercedes Vito en buen estado, color azul metalizado, ideal para transporte de personas o mercancías ligeras.",
    image: "https://public.readdy.ai/ai/img_res/edited_9d4927ccf9c5489c6d893cc4fab1d34e_a88d680d.jpg",
    badge: null,
  },
  {
    id: 3,
    brand: "Opel",
    model: "Vivaro",
    year: 2021,
    km: 62000,
    price: 14900,
    fuel: "Diésel",
    transmission: "Manual",
    color: "Blanco",
    description: "Furgoneta compacta en excelente estado, muy maniobrable, ideal para reparto urbano y trabajos de servicio técnico.",
    image: "https://public.readdy.ai/ai/img_res/edited_e03ee8e0300e3eb0e9ae88e3d7aa674c_1a0d90a6.jpg",
    badge: "Nuevo",
  },
  {
    id: 4,
    brand: "Iveco",
    model: "Daily 35S14",
    year: 2018,
    km: 145000,
    price: 14500,
    fuel: "Diésel",
    transmission: "Manual",
    color: "Blanco",
    description: "Camión ligero muy versátil, carrocería cerrada, ideal para mudanzas y transporte de palés.",
    image: "https://readdy.ai/api/search-image?query=white%20Iveco%20Daily%20light%20truck%20isolated%20on%20white%20background%2C%20professional%20automotive%20photography%2C%20side%20view%2C%20commercial%20vehicle&width=600&height=400&seq=v4&orientation=landscape",
    badge: null,
  },
  {
    id: 5,
    brand: "Volkswagen",
    model: "Crafter 35",
    year: 2022,
    km: 31000,
    price: 39900,
    fuel: "Diésel",
    transmission: "Automático",
    color: "Plateado",
    description: "Casi nuevo, garantía de fábrica vigente. Equipado con cámara trasera y sensores de aparcamiento.",
    image: "https://readdy.ai/api/search-image?query=silver%20Volkswagen%20Crafter%20van%20on%20white%20background%2C%20professional%20vehicle%20photography%2C%20side%20view%2C%20modern%20commercial%20van&width=600&height=400&seq=v5&orientation=landscape",
    badge: "Casi nuevo",
  },
  {
    id: 6,
    brand: "Peugeot",
    model: "Boxer 330",
    year: 2020,
    km: 78000,
    price: 17200,
    fuel: "Diésel",
    transmission: "Manual",
    color: "Blanco",
    description: "Furgón de carga con techo elevado, amplio espacio interior, perfecto para profesionales autónomos.",
    image: "https://readdy.ai/api/search-image?query=white%20Peugeot%20Boxer%20van%20isolated%20on%20white%20background%2C%20professional%20automotive%20photography%2C%20side%20view%2C%20cargo%20van&width=600&height=400&seq=v6&orientation=landscape",
    badge: null,
  },
];

export const vehicleFilters = {
  brands: ["Todos", "Ford", "Mercedes-Benz", "Opel", "Iveco", "Volkswagen", "Peugeot"],
  fuels: ["Todos", "Diésel", "Gasolina", "Eléctrico", "Híbrido"],
  transmissions: ["Todos", "Manual", "Automático"],
};
